{
    "nav": {
        "console": "Agent console",
        "wallboard": "Wallboard",
        "reporting": "Contact centre reports",
        "configuration": "Queues & agents",
        "chatbot": "Chatbot",
        "ivr": "IVR designer",
        "licensing": "Licensing"
    },
    "console": {
        "title": "Agent console",
        "signed_out": "You are signed out",
        "signed_out_help": "Sign in to start taking contacts.",
        "sign_in": "Sign in",
        "sign_out": "Sign out",
        "state": "My state",
        "reason": "Reason",
        "next": "Take next",
        "nothing_waiting": "Nothing waiting that you can take.",
        "waiting": "Waiting",
        "no_contact": "No contact open",
        "no_contact_help": "Take the next contact, or wait for one to be routed to you.",
        "answer": "Answer",
        "hold": "Hold",
        "resume": "Take off hold",
        "end": "End",
        "close": "Close and record",
        "transfer": "Transfer",
        "internal_note": "Internal note",
        "send": "Send",
        "message_placeholder": "Type a reply…",
        "internal_hint": "Only colleagues can see internal notes.",
        "wrap_up": "Record the outcome",
        "disposition": "Outcome",
        "notes": "Notes",
        "resolved_first_contact": "Resolved on this contact",
        "transfer_to_agent": "To a colleague",
        "transfer_to_queue": "To a queue",
        "announced": "Introduce the customer first",
        "note": "Note for the receiving agent",
        "load": "{{count}} open",
        "capacity_voice": "Voice takes one at a time",
        "skills": "Skills",
        "waiting_seconds": "Waiting {{time}}",
        "talk_time": "Talking {{time}}",
        "on_hold": "On hold {{time}}",
        "customer": "Customer",
        "open_complaints": "{{count}} open complaints",
        "open_record": "Open customer record",
        "unidentified": "Not yet identified",
        "vip": "VIP",
        "bot_handled": "Started with the chatbot",
        "transferred_in": "Transferred in"
    },
    "wallboard": {
        "title": "Contact centre",
        "subtitle": "Live",
        "waiting": "Waiting",
        "longest_wait": "Longest wait",
        "active": "In progress",
        "held": "On hold",
        "signed_in": "Signed in",
        "available": "Available",
        "busy": "On a contact",
        "on_break": "Away",
        "queues": "Queues",
        "agents": "Agents",
        "queue": "Queue",
        "target": "Target",
        "state": "State",
        "for_time": "for {{time}}",
        "callbacks": "Callbacks",
        "callbacks_pending": "Waiting",
        "callbacks_overdue": "Overdue",
        "callbacks_failed": "Failed today",
        "today": "Today",
        "arrived": "Arrived",
        "answered": "Answered",
        "abandoned": "Abandoned",
        "asa": "Average answer",
        "aht": "Average handling",
        "service_level": "Service level",
        "fcr": "First-contact resolution",
        "no_data": "No contacts in this period.",
        "supervise": "Listen in",
        "monitor": "Listen",
        "whisper": "Whisper to agent",
        "barge": "Join the call",
        "assign": "Assign to…",
        "alerts": {
            "ok": "Within target",
            "warning": "Over target",
            "critical": "Well over target"
        }
    },
    "reporting": {
        "title": "Contact centre reports",
        "from": "From",
        "to": "To",
        "queue": "Queue",
        "all_queues": "All queues",
        "run": "Run",
        "by_channel": "By channel",
        "by_agent": "By agent",
        "agent": "Agent",
        "handled": "Handled",
        "aht": "Average handling",
        "transfers": "Transfers",
        "occupancy": "Occupancy",
        "signed_in": "Signed in",
        "export": "Export CSV"
    },
    "configuration": {
        "title": "Queues & agents",
        "queues": "Queues",
        "skills": "Skills",
        "agents": "Agents",
        "dispositions": "Outcomes",
        "code": "Code",
        "name": "Name",
        "name_en": "Name (English)",
        "name_ar": "Name (Arabic)",
        "skill": "Skill",
        "channels": "Channels",
        "target": "Answer target (seconds)",
        "priority": "Priority",
        "overflow": "Overflow to",
        "overflow_after": "Overflow after (seconds)",
        "after_hours": "Out of hours",
        "callback_after": "Offer callback after (seconds)",
        "active": "Active",
        "save": "Save",
        "new_queue": "Add queue",
        "edit": "Edit",
        "extension": "Extension",
        "max_chats": "Concurrent chats",
        "accepts_voice": "Takes calls",
        "accepts_chat": "Takes chats",
        "proficiency": "Proficiency",
        "has_seat": "Licensed",
        "no_seat": "No seat",
        "telephony": "Telephony platform",
        "telephony_simulated": "Running on the built-in simulator — no calls leave this system.",
        "telephony_offshore": "Hosted abroad: call audio would leave the country.",
        "after_hours_options": {
            "callback": "Offer a callback",
            "voicemail": "Take a voicemail",
            "closed": "Say we are closed",
            "overflow": "Send to the overflow queue"
        }
    },
    "chatbot": {
        "title": "Chatbot",
        "intents": "Intents",
        "code": "Code",
        "name": "Name",
        "patterns_en": "Trigger phrases (English)",
        "patterns_ar": "Trigger phrases (Arabic)",
        "response_en": "Reply (English)",
        "response_ar": "Reply (Arabic)",
        "escalates": "Hand to a person",
        "escalate_to": "Escalate to",
        "quick_replies": "Suggested replies",
        "matched": "Matched",
        "escalated": "Escalated",
        "escalation_rate": "Escalation rate",
        "active": "Active",
        "save": "Save intent",
        "new": "Add intent",
        "test": "Try it",
        "test_message": "Type a customer message",
        "test_result": "Matched {{intent}} at {{confidence}}",
        "test_none": "No intent matched — this would go to a person.",
        "add_pattern": "Add phrase",
        "patterns_hint": "Both languages are searched whatever the customer is using.",
        "add_phrase": "Add a phrase"
    },
    "ivr": {
        "title": "IVR designer",
        "flow": "Flow",
        "inbound_number": "Inbound number",
        "node": "Step",
        "type": "Type",
        "digit": "Reached by pressing",
        "prompt_en": "Prompt (English)",
        "prompt_ar": "Prompt (Arabic)",
        "queue": "Queue",
        "add_child": "Add a step under this",
        "remove": "Remove",
        "save": "Save flow",
        "reached": "{{count}} callers reached this",
        "entry": "Entry point",
        "types": {
            "menu": "Menu",
            "message": "Message",
            "queue": "Send to a queue",
            "callback": "Offer a callback",
            "voicemail": "Voicemail",
            "hangup": "End the call",
            "language": "Choose language"
        },
        "preview": "Preview",
        "preview_hint": "Walks the same tree a real call would.",
        "press": "Press {{digit}}",
        "restart": "Start again"
    },
    "licensing": {
        "title": "Licensing",
        "licensed": "Licensed seats",
        "granted": "Granted",
        "signed_in": "Signed in now",
        "peak": "Peak concurrent",
        "peak_at": "reached {{when}}",
        "mean": "Average concurrent",
        "headroom": "Headroom",
        "seats": "Seats",
        "agent": "Agent",
        "type": "Type",
        "granted_at": "Granted",
        "expires": "Expires",
        "reason": "Reason",
        "grant": "Grant a seat",
        "revoke": "Revoke",
        "permanent": "Permanent",
        "temporary": "Temporary",
        "never": "Does not expire",
        "usage": "Usage",
        "recommendations": {
            "unconfigured": "No seat limit is configured.",
            "at_capacity": "The licence is fully used — the next sign-in will be refused.",
            "approaching_capacity": "Usage is close to the licensed limit.",
            "over_licensed": "Usage is well below the licensed limit.",
            "healthy": "Usage is comfortably within the licence."
        }
    },
    "widget": {
        "title": "Chat to us",
        "open": "Chat to us",
        "closed_now": "Our chat is closed at the moment.",
        "placeholder": "Type your message…",
        "send": "Send",
        "start": "Start a conversation",
        "waiting_for_agent": "Waiting for a colleague — you are number {{position}} in the queue.",
        "with_agent": "You are speaking to {{name}}",
        "bot": "Assistant",
        "you": "You",
        "request_callback": "Ask us to ring you",
        "phone": "Mobile number",
        "name": "Name (optional)",
        "callback_sent": "Thank you — we will ring you back.",
        "estimated_wait": "About {{count}} minutes",
        "new_conversation": "Start a new conversation"
    },
    "status": {
        "queued": "Waiting",
        "ringing": "Ringing",
        "active": "In progress",
        "held": "On hold",
        "wrap_up": "Wrapping up",
        "closed": "Closed",
        "abandoned": "Abandoned"
    },
    "agent_status": {
        "available": "Available",
        "busy": "On a contact",
        "wrap_up": "Wrapping up",
        "break": "On a break",
        "training": "In training",
        "meeting": "In a meeting",
        "offline": "Signed out"
    },
    "channel": {
        "phone": "Phone",
        "chat": "Web chat",
        "whatsapp": "WhatsApp",
        "email": "Email",
        "sms": "SMS",
        "social_media": "Social media"
    }
}
